import React from 'react';

const ResizableDiv = ({ children, className = '' }) => {
  return (
    <div
      contentEditable
      style={{ 
        minWidth: '360px',
        background: '#f3f6f8'
      }}
      className={`w-full max-w-full h-fit border border-gray-300 resize-x overflow-auto p-4 rounded-lg focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-200 ${className}`}
    >
      {children}
    </div>
  );
};

export default ResizableDiv;